import {ImageRequestParams} from "../models/image/image-request-params";

export class MegaphoneImageRequestParams extends ImageRequestParams {
  constructor(width, color) {
    super({color, width});

    this._resourceName = `bolao26/Icons/Megaphone`;
    this.ratio = 3;
    this.c = null;
  }
}
